import { DeepPartial } from "@towersystems/roam-common/lib/shared-types";
import { GraphicCode, InputType } from "../../types";
import { PosApiResponse } from "../pos-api-response";

export class DisplayResponse extends PosApiResponse {
  constructor(input?: DeepPartial<DisplayResponse>) {
    super(input);
    // Re-apply after super(): subclass field declarations reset declared
    // properties to undefined once super() returns, wiping the values
    // BaseResponse copied. Re-assigning here restores the API payload.
    if (input) {
      Object.assign(this, input);
    }
    if (!this.DisplayText) {
      this.DisplayText = [];
    }
  }

  // Number of lines to display.
  public NumberOfLines: number;

  // Number of character per display line.
  public LineLength: number;

  // Text to be displayed. Each display line is concatenated.</summary>
  // Example: [&quot;     SWIPE CARD     &quot;,&quot;                    &quot;]
  public DisplayText: string[];

  //Indicates whether the Cancel button is to be displayed.
  public CancelKeyFlag: boolean;

  //Indicates whether the Accept/Yes button is to be displayed
  public AcceptYesKeyFlag: boolean;

  // Indicates whether the Decline/No button is to be displayed.
  public DeclineNoKeyFlag: boolean;

  // Indicates whether the Authorise button is to be displayed.
  public AuthoriseKeyFlag: boolean;

  //Indicates whether the OK button is to be displayed.
  public OkKeyFlag: boolean;

  // Indicates whether the Clear button is to be displayed.
  public InputType: InputType;

  // The graphic code to display on the PIN pad.
  public GraphicCode: GraphicCode;
}
